export type TransactionSearchOptions = 'General' | 'Account' | 'User' | 'Customer' | 'Type' | 'Method' | 'AVS' | 'CSC' | 'or Account'

export interface TransactionTotals {
  count: number;
  amount: number;
}

export interface TransactionSummaryTotals {
  totalCount: number;
  totalAmount: number;
}

// This data can be calculated off of list transactions but think done in backend makes more sense
export interface CardMetric {
  purchases: { pending: TransactionTotals; settled: TransactionTotals };
  refunds: { pending: TransactionTotals; settled: TransactionTotals };
}

// Summary of transaction search results grouped by card brands.
export interface CardTransactionSummary {
  cardBrand: 'VISA' | 'MASTERCARD' | 'DISCOVER' | 'AMEX' | string;
  metrics: CardMetric; // metrics for captured and non-captured totals for purchases and refunds
}

// Transaction search results
export interface CardTransaction {
  id: number;
  cardNumber: string;
  cardBrand: string;
  amount: number;
  approval_code: string;
  total_amount_with_surcharge: number;
  avs: string;
  csc: string;
  status: string;
  user_name: string;
  billing_name: string;
  invoice: string;
  processMethod: string;
  user: string;
  processed: string;
  settled: string;
  eligibility_level: string,
  card_type: string,
  is_refund: boolean,
  discretionary_data: Record<string, string>
  processing_system?: string
  settlement_system?: string
  processing_service?: string
}

export enum SearchStatus {
  Initial = 'initial',
  Searching = 'loading',
  Error = 'error',
  Success = 'found',
  NotFound = 'notfound',
}

// Shape of transaction view search response
export interface TransactionSearchResponse {
  summary: TransactionSummaryTotals;
  cardSummaries: CardTransactionSummary[];
  transactions: CardTransaction[];
}
